export default {
goToTop() {
    //往上滚的方法
    let top = this.getBrowserInfo() == 2 ? document.body.scrollTop : document.documentElement.scrollTop;
    // 实现滚动效果
    const timeTop = setInterval(() => {
      this.getBrowserInfo() == 2 ? (document.body.scrollTop = top -= 50) : (document.documentElement.scrollTop = top -= 50);
      if (0 >= top) {
        this.getBrowserInfo() == 2 ? (document.body.scrollTop = 0) : (document.documentElement.scrollTop = 0);
        clearInterval(timeTop); //清除定时器
      }
    }, 10);
  },
  //获取当前浏览器类型和版本号
  getBrowserInfo() {
    var agent = navigator.userAgent.toLowerCase();
    var regStr_ie = /msie [\d.]+;/gi;
    var regStr_ff = /firefox\/[\d.]+/gi;
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    var version = /version\/[\d.]+/gi;
    //IE11以下
    if (agent.indexOf("msie") > 0) {
      // return agent.match(regStr_ie) ;
      return 0;
    }
    //IE11版本中不包括MSIE字段
    if (agent.indexOf("trident") > 0 && agent.indexOf("rv") > 0) {
      // return "IE " + agent.match(/rv:(\d+\.\d+)/) [1];
      return 0;
    }
    //firefox
    if (agent.indexOf("firefox") > 0) {
      // return agent.match(regStr_ff) ;
      return 0;
    }
    //Chrome
    if (agent.indexOf("chrome") > 0) {
      // return agent.match(regStr_chrome) ;
      return 1;
    }
    //Safari
    if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
      // return agent.match(regStr_saf) ;
      let verinfo = (agent.match(version) + "").replace(/[^0-9.]/gi, "");
      if (verinfo.substring(0, 2) >= 13) {
        return 1;
      } else {
        return 2;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/public.js